import React, { useState } from "react";
import CloseIcon from '@material-ui/icons/Close';
import {
  Link as MuiLink,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Grid,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  MenuItem,
  Select,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  Divider,
} from "@material-ui/core";
import { useTable, useSortBy, useFilters, useGlobalFilter, usePagination, useRowSelect } from "react-table";
import { Link } from "react-router-dom";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import { formatDate } from "../../../common/formatDate";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import { toast } from "react-toastify";
import { useInventoryUpdate } from "../../../intake/intakeQueries";
import { useFetchContext } from "../../../common/FetchContext";
import { values } from "lodash";
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from "@material-ui/lab";
import { Cached, Error, History, Pause, Save } from "@material-ui/icons";
import HistoryTimeLine from "./HistoryTimeLine";
import LSDBPaginatedTable from "../../../common/LSDBPaginatedTable";
import { LSDBCoreTableWithoutDropDown } from "../../../common/LSDBCoreTableWithoutDropDown";
import { urls } from "../../../common/urls";
import moment from "moment";
import { getTheme } from "../../../common/getLocalTheme";
import { useUpdateEolDisposition } from "../../../dataEgress/dataEgressMutations";
import { useQueryClient } from "react-query";


const dateFormatter = (dateToFormat: Date) => {
  return `${dateToFormat.toDateString()} ${dateToFormat
    .getUTCHours()
    .toString()
    .padStart(2, "0")}:${dateToFormat
      .getUTCMinutes()
      .toString()
      .padStart(2, "0")}:${dateToFormat
        .getUTCSeconds()
        .toString()
        .padStart(2, "0")}`;
};

export const ModuleInventoryTablePage = ({ data, dispositions, locations, serialNumbers }: any) => {
  const defaultColumn = useDefaultColumn();
  const [open, setOpen] = React.useState(false);
  const [selectedSerial, setSelectedSerial] = React.useState('');
  const [selectedSerialNumbers, setSelectedSerialNumbers] = React.useState<string[]>([]);

  const { mutateAsync: mutate } = useInventoryUpdate();
  const { authAxios } = useFetchContext();






  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, rowData: any) => {
    e.preventDefault(); // Prevent actual link navigation
    setOpen(true); // Open the dialog
  };
  const [reloadHistory, setReloadHistory] = React.useState(false);

  const handleClose = () => {
    setOpen(false); // Close the dialog

    setReloadHistory((prev) => !prev);
  };


  const getDownloads = async (): Promise<any> => {
    const response = await authAxios.get(urls.units.locationHistoryDownload(selectedSerial), {
      responseType: 'blob'
    });

    const downloadUrl = URL.createObjectURL(response.data);
    let a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
    document.body.appendChild(a);
    a.click();
  };

  const columns = React.useMemo(
    () => [
      {
        id: "Id",
        accessor: "id",
      },
      {
        id: "module_height",
        accessor: 'module_specification.module_height'
      },
      {
        id: "Serial",
        accessor: "serial_number",
        Header: 'Serial Number',
        Cell: ({ cell, row }: any) => (
          <MuiLink component={Link} to={`/operations_management/module_inventory/${cell.value}`}>
            {cell.value}
          </MuiLink>
        ),
      },
      {
        id: "Number",
        accessor: "project_number",
        Header: 'Project Number',
      },
      {
        id: "Work Order",
        Header: 'Work Order',
        accessor: "workorder_name",
      },
      {
        id: 'Customer',
        Header: 'Customer',
        accessor: 'customer_name'
      },
      {
        id: 'Manufacturer',
        Header: 'Manufacturer',
        accessor: 'customer_name'
      },

      {
        Header: 'Location',
        id: "Location",
        accessor: "location_id",
        filter: generalFilter,
        Cell: ({ row }: any) => {
          // Get the serial number from the current row
          const serial = row.values.Serial;

          // onChange handler for the Select dropdown
          const handleChange = async (e: React.ChangeEvent<{ value: any }>) => {
            const newLocation = e.target.value as string;

            console.log("Form values", serial, newLocation);
            await mutate({
              authAxios,
              serial_number: serial, // Pass serial number to the API
              location: newLocation, // Pass new location to the API
            });
            toast.success("Project disposition status updated successfully");
          };

          function onHistoryClick(Serial: any) {
            setOpen(true);
            setSelectedSerial(Serial)
          }

          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                labelId="location_select"
                id="location_select"
                disableUnderline
                defaultValue={row.values.Location}
                label="Location"
                disabled={getTheme()}
                onChange={handleChange}
              >
                {locations?.map((location: any) => (
                  <MenuItem key={location.id} value={location.id}>
                    {location.name}
                  </MenuItem>
                ))}
              </Select>
              <IconButton onClick={() => { onHistoryClick(row.values.Serial); }}><History color="primary"></History></IconButton>
            </div>
          );
        },
      },
      {
        Header: 'Intake Location',
        accessor: 'intake_location'
      },

      {
        Header: 'Eol Disposition',
        id: "Disposition",
        accessor: "eol_disposition",
        filter: generalFilter,
        Cell: ({ row }: any) => {
          const serial = row.values.Serial;
          const handleChange = async (e: React.ChangeEvent<{ value: any }>) => {
            var newDisposition = e.target.value as string;
            console.log("Form values", serial);
            await mutate({
              authAxios,
              serial_number: serial,
              eol_disposition: newDisposition,
            });
            toast.success("Project disposition status updated successfully");
          };

          return (
            <Select
              labelId="disposition_select"
              id="disposition_select"
              disableUnderline
              defaultValue={row.values.Disposition}
              label="Disposition"
              disabled={getTheme()}
              onChange={handleChange}>
              {dispositions?.map((disposition: any) => (
                <MenuItem key={disposition.id}
                  value={disposition.id}>
                  {disposition.name}
                </MenuItem>
              ))}
            </Select>
          );
        },
      },
      {
        Header: 'CloseOut Date',
        id: "CloseOut Date",
        accessor: "project_closeout_date",
        Cell: ({ cell }: any) =>
          cell.value ? <p>{dateFormatter(new Date(cell.value))}</p> : <p>N/A</p>,
      },
      {
        Header: 'Arrival Date',
        id: "Arrival Date",
        accessor: "arrival_date",
        Cell: ({ cell }: any) =>
          cell.value ? <p>{dateFormatter(new Date(cell.value))}</p> : <p>N/A</p>,
        filter: generalFilter,
      },

      {
        Header: 'Intake Complete',
        id: 'intake_complete',
        accessor: "arrival_date",
        Cell: ({ cell }: any) =>
          cell.value ? <p>{dateFormatter(new Date(cell.value))}</p> : <p>N/A</p>,
      },
      {
        Header: 'NTP',
        id: 'ntp_date',
        accessor: 'ntp_date',
        Cell: ({ cell }: any) =>
          cell.value ? <p>{dateFormatter(new Date(cell.value))}</p> : <p>N/A</p>,
      },
      {
        Header: 'Model Type',
        id: 'module_type',
        accessor: 'module_type'
      },
      {
        Header: 'Test Sequence',
        id: 'test_sequence_name',
        accessor: 'test_sequence_name',
      },
      {
        Header: 'Cell Type',
        id: 'module_technology_name',
        accessor: 'module_specification.module_technology_name'
      },
      {
        Header: 'Module Dimensions',
        id: 'module_dim',
        accessor: 'module_specification.module_width',
        Cell: ({ cell, row }: any) => (
          <label>{cell.value}X{row.values.module_height}</label>
        ),
      },
      {
        Header: 'Mpp',
        id: 'Mpp',
        accessor: 'module_specification.nameplate_pmax'
      },
      {
        Header: 'Voc',
        id: 'Voc',
        accessor: 'module_specification.voc'
      },
      {
        Header: 'Isc',
        id: 'Isc',
        accessor: 'module_specification.isc'
      },
      {
        Header: 'Vmp',
        id: 'Vmp',
        accessor: 'module_specification.vmp'
      },
      {
        Header: 'Imp',
        id: 'Imp',
        accessor: 'module_specification.imp'
      },
      {
        Header: 'Rated Voltage',
        id: 'Rated Voltage',
        accessor: 'module_specification.system_voltage'
      },

    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: ["Id", "module_height"],
      },
    },
    
    
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <Checkbox color="primary" {...getToggleAllRowsSelectedProps()} />
          ),
          Cell: ({ row }) => {
            const serial = (row.original as { serial_number: string }).serial_number;

            const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
              const checked = event.target.checked;

              setSelectedSerialNumbers((prev) => {
                let updatedSerials;

                if (checked) {
                  updatedSerials = [...prev, serial];
                } else {
                  updatedSerials = prev.filter((s) => s !== serial);
                }

                
                serialNumbers(updatedSerials);

                return updatedSerials;
              });

              row.toggleRowSelected(checked);
            };

            return (
              <Checkbox
                color="primary"
                checked={row.isSelected}
                onChange={handleChange}
              />
            );
          },
        },
        ...columns,
      ]);
    }

  );




  return (
    <>
      <div style={{ overflowX: 'auto', width: '100%' }}>

        {/* <LSDBCoreTableWithoutDropDown
          columns={columns}
          data={data}
          hiddenColumns={["Id", "module_height"]}
          enableRowSelection={true}
          onSelectionChange={(selectedRows) => {
            // const serialNumbers = selectedRows.map((row) => row.original.serial_number);
            const serialNumbers = selectedRows.map((row) => (row.original as any).serial_number);
            console.log("Selected Serial Numbers:", serialNumbers);

            setSelectedSerialNumber(serialNumbers);
            { handleClick }
          }}
        /> */}

        <TableContainer data-testid="tableContainer" component={Paper}>
          <TableHead>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <TableCell
                    key={column.id}
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      width: '100%',
                      backgroundColor: "green",
                      color: "white",
                    }}
                  >
                    <Typography variant="subtitle1">
                      {column.render("Header")}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <TableRow {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell: any) => (
                    <TableCell
                      key={cell.column.id}
                      style={{
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}>
                      {cell.render("Cell")}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </TableContainer>

        <Dialog open={open} onClose={handleClose} fullWidth>
          <DialogTitle>Location History     <IconButton onClick={getDownloads}><Save color="primary" /></IconButton></DialogTitle>
          <DialogContent>
            <HistoryTimeLine serial_number={selectedSerial} reloadHistory={reloadHistory}></HistoryTimeLine>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>

    </>
  );







};


